export const excludedNetworkPaths = [
  'disney-junior',
  'disney-xd',
  'freeform',
  'fxm',
  'fxx',
  'national-geographic-wild',
];

export const excludedNetworkNames = [
  'Disney Junior',
  'Disney XD',
  'Freeform',
  'FXX',
  'FXM',
  'National Geographic Wild',
];
